import React, { Component} from 'react';
import PropTypes from "prop-types";
import { Translation } from 'react-i18next';

import { connect } from "react-redux";
import {
  fetchLocationLinksList,
  applyLocationLinkDrag,
  clearCreateLocationLink,
  clearPatchLocationLink,
  clearDeleteLocationLink,
  clearLocationLinkDrag,
  clearCreateLocationMarker,
  clearPatchLocationMarker,
  clearDeleteLocationMarker,
} from 'redux/location-links/actions';

import { resetLastPatchedId } from 'redux/common/actions';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";
import { Loader } from 'semantic-ui-react';

import { Link } from 'react-router-dom';

import LocationLinkItem from 'components/dashboard/location-links-content/LocationLinkItem';
import CommonMessage from 'components/common/CommonMessage';
import LocationLinksEmptyPlaceholder
  from 'components/dashboard/location-links-content/LocationLinksEmptyPlaceholder';

import './LocationLinksList.css';


class LocationLinksList extends Component {
  static propTypes = {
    fetchLocationLinksList: PropTypes.func.isRequired,
    applyLocationLinkDrag: PropTypes.func.isRequired,
    clearCreateLocationLink: PropTypes.func.isRequired,
    clearPatchLocationLink: PropTypes.func.isRequired,
    clearDeleteLocationLink: PropTypes.func.isRequired,
    clearLocationLinkDrag: PropTypes.func.isRequired,
    resetLastPatchedId: PropTypes.func.isRequired,
    clearCreateLocationMarker: PropTypes.func.isRequired,
    clearPatchLocationMarker: PropTypes.func.isRequired,
    clearDeleteLocationMarker: PropTypes.func.isRequired,
    locationLinksList: PropTypes.arrayOf(PropTypes.shape),
    locationLinksListError: PropTypes.object,
    createLocationLinkSuccess: PropTypes.object,
    patchLocationLinkSuccess: PropTypes.object,
    deleteLocationLinkSuccess: PropTypes.object,
    locationLinkDrugSuccess: PropTypes.object,
    createLocationMarkerSuccess: PropTypes.object,
    patchLocationMarkerSuccess: PropTypes.object,
    deleteLocationMarkerSuccess: PropTypes.object,
    me: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    locationLinksList: null,
    locationLinksListError: null,
    createLocationLinkSuccess: null,
    patchLocationLinkSuccess: null,
    deleteLocationLinkSuccess: null,
    locationLinkDrugSuccess: null,
    createLocationMarkerSuccess: null,
    patchLocationMarkerSuccess: null,
    deleteLocationMarkerSuccess: null,
  };

  state = {
    items: null,
  };

  componentDidMount() {
    this.setState({ items: this.props.locationLinksList });
  }

  componentDidUpdate(prevProps) {
    // Set Current List
    if (prevProps.locationLinksList !== this.props.locationLinksList) {
      this.setState({ items: this.props.locationLinksList });
    }

    // Create Link
    if (
      !prevProps.createLocationLinkSuccess &&
      prevProps.createLocationLinkSuccess !== this.props.createLocationLinkSuccess
    ) {
      this.props.fetchLocationLinksList();
      this.props.clearCreateLocationLink();
    }

    // Patch Link
    if (
      !prevProps.patchLocationLinkSuccess &&
      prevProps.patchLocationLinkSuccess !== this.props.patchLocationLinkSuccess
    ) {
      this.props.fetchLocationLinksList();
      this.props.clearPatchLocationLink();
      this.props.resetLastPatchedId();
    }

    // Delete Link
    if (
      !prevProps.deleteLocationLinkSuccess &&
      prevProps.deleteLocationLinkSuccess !== this.props.deleteLocationLinkSuccess
    ) {
      this.props.fetchLocationLinksList();
      this.props.clearDeleteLocationLink();
    }

    // Drag Link
    if (
      !prevProps.locationLinkDrugSuccess &&
      prevProps.locationLinkDrugSuccess !== this.props.locationLinkDrugSuccess
    ) {
      this.props.fetchLocationLinksList();
      this.props.clearLocationLinkDrag();
    }

    // Create Marker
    if (
      !prevProps.createLocationMarkerSuccess &&
      prevProps.createLocationMarkerSuccess !== this.props.createLocationMarkerSuccess
    ) {
      this.props.fetchLocationLinksList();
      setTimeout(() => {
        this.props.clearCreateLocationMarker();
      }, 300);
    }

    // Patch Marker
    if (
      !prevProps.patchLocationMarkerSuccess &&
      prevProps.patchLocationMarkerSuccess !== this.props.patchLocationMarkerSuccess
    ) {
      this.props.fetchLocationLinksList();
      this.props.clearPatchLocationMarker();
    }

    // Delete Marker
    if (
      !prevProps.deleteLocationMarkerSuccess &&
      prevProps.deleteLocationMarkerSuccess !== this.props.deleteLocationMarkerSuccess
    ) {
      this.props.fetchLocationLinksList();
      this.props.clearDeleteLocationMarker();
    }
  }

  componentWillUnmount() {
    this.props.resetLastPatchedId();
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items }, () => {
      const form = new FormData();
      this.state.items.map(item => item.id)
        .forEach(item => form.append('order', item));
      this.props.applyLocationLinkDrag(form);
    });
  };

  renderLocationLinksList = () => {
    const { items } = this.state;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items && items.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      className="list-wrapper"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <LocationLinkItem
                        key={`location-link-item-key-${item.id}`}
                        item={item}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { me, locationLinksList, locationLinksListError } = this.props;
    const { items } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="location-links-list__component">
            {/* Loader */}
            {!locationLinksList && !locationLinksListError &&
              <Loader active />
            }

            {/* Links List */}
            {items && items.length > 0 &&
              <div className="links-list-container">
                {this.renderLocationLinksList()}
              </div>
            }

            {/* List Error */}
            {locationLinksListError &&
              <CommonMessage
                error
                errors={locationLinksListError}
              />
            }

            {/* Empty Placeholder */}
            {locationLinksList && locationLinksList.length === 0 &&
              <LocationLinksEmptyPlaceholder />
            }

            {/* Undertext */}
            <div className="undertext">
              {(me && me.subscription && me.subscription.ff_maps) ?
                <div>
                  {t("You are PRO! You can manage multiple locations & places")}
                </div>
                :
                <div>
                  {t("You can manage multiple locations on the PRO plan.")}
                  {t("Check it")} <Link to="/billing">{t("here")}</Link>
                </div>
              }
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    locationLinksList: state.locationLinksReducer.locationLinksList,
    locationLinksListError: state.locationLinksReducer.locationLinksListError,
    createLocationLinkSuccess: state.locationLinksReducer.createLocationLinkSuccess,
    patchLocationLinkSuccess: state.locationLinksReducer.patchLocationLinkSuccess,
    deleteLocationLinkSuccess: state.locationLinksReducer.deleteLocationLinkSuccess,
    locationLinkDrugSuccess: state.locationLinksReducer.locationLinkDrugSuccess,
    createLocationMarkerSuccess: state.locationLinksReducer.createLocationMarkerSuccess,
    patchLocationMarkerSuccess: state.locationLinksReducer.patchLocationMarkerSuccess,
    deleteLocationMarkerSuccess: state.locationLinksReducer.deleteLocationMarkerSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchLocationLinksList,
    applyLocationLinkDrag,
    clearCreateLocationLink,
    clearPatchLocationLink,
    clearDeleteLocationLink,
    clearLocationLinkDrag,
    resetLastPatchedId,
    clearCreateLocationMarker,
    clearPatchLocationMarker,
    clearDeleteLocationMarker,
  },
)(LocationLinksList);
